<template>
  <div>
    <!-- BEGIN CONTENT BODY -->
    <!-- BEGIN PAGE HEADER-->
    <breadcrumbs
      :crumbs="[{name: `${participantSingularName} Dashboard`, link:'Dashboard Participant', id: $route.params.id}, {name: 'Activities and Services'}]"
    />
    <!--END PAGE HEADER-->
    <div class="row">
      <div class="col-md-8">
        <div class="row">
          <div class="col-md-6 db-column" id="first-column">
            <profile-participant></profile-participant>
          </div>
          <div class="col-md-6 db-column" id="second-column">
            <assingment></assingment>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <form-crud type="activities_services" :sortByName="true" v-on:refresh-communication-notes="loadParticipant($route.params.id)"></form-crud>
          </div>
        </div>
      </div>
      <div class="col-md-4 db-column" id="third-column">
        <case-notes></case-notes>
      </div>
    </div>
    <!--END CONTENT BODY-->
  </div>
</template>
<script>
  import ProfileParticipant from '@/components/widgets/ProfileParticipant';
  import Assingment from '@/components/widgets/Assingment';
  import CaseNotes from '@/components/widgets/CaseNotes';
  import FormCrud from '@/components/widgets/FormCRUD';
  import Breadcrumbs from '@/components/Breadcrumbs'
  import {mapActions} from 'vuex';
  import participantDisplayName from '@/mixins/participantDisplayName';

  export default {
    mixins: [
      participantDisplayName
    ],
    beforeMount() {
      if (this.$route.params.id) {
        this.loadParticipant(this.$route.params.id);
      } else {
        this.$notify({type: 'error', text: 'Wrong participant'});
        this.$router.push({name: 'Participant Directory'});
      }
    },

    methods: {
      ...mapActions([
        'loadParticipant'
      ]),
    },

    components: {
      ProfileParticipant,
      Assingment,
      CaseNotes,
      FormCrud,
      Breadcrumbs
    }
  }
</script>



// WEBPACK FOOTER //
// ActivitiesAndServices.vue?34bdda57